import React from 'react';
import { Result, Button } from 'antd';

const Error500M = () => (
  <Result
    status="500"
    title="500"
    subTitle="系統異常！請重新操作，或聯絡相關人員。"
  />
);

export default Error500M;
